module.exports = __webpack_public_path__ + "../../static/vue-contratar/img/logo-aawz@3x.98c08189.png";